export const clientConfig = {
  environment: process.env.REACT_APP_ENVIRONMENT || 'local',
  apiUrl:  process.env.REACT_APP_API_URL,
  version: process.env.REACT_APP_VERSION,
  gameProvidersEnabled: false
};